import { useDragEvent } from "../../../hooks/useDragEvent";
import { PopupLinkOption, PopupVO } from "../../../types/popup";
import style from "./popups.module.scss";
import { useCallback } from "react";
import {useAuth, useModal, useUserAgent} from "../../../hooks/hooks";
import {useCookie} from "../../../hooks/auth/useCookie";
import {ModalType} from "../../../types/common";
import {CookieKeys} from "../../../hooks/auth/AuthProvider";

interface Props {
  moveNext?: () => void;
  movePrev?: () => void;
  popupVO: PopupVO;
  setShowPopups: (_:boolean) => void
}

export function APopup({ moveNext, movePrev, popupVO, setShowPopups }: Props) {
  const { handleDragStart, handleDragEnd } = useDragEvent({
    moveRight: () => moveNext?.(),
    moveLeft: () => movePrev?.(),
  });

  /**
   * 두뇌유형 검사용 임시 처리
   */
  const {getValueFromCookie} = useCookie();
  const {isLoggedIn} = useAuth();
  const {isDesktop} = useUserAgent();
  const {openAlertModal, openModal, openConfirmModal} = useModal();

  const onClickPopup = useCallback(() => {
    // if (!popupVO.imageLink) return;
    //
    // window.open(popupVO.imageLink, popupVO.linkOption === PopupLinkOption.NEW_TAB ? "_blank" : "_self");
    if (!popupVO.imageLink) setShowPopups(false);

    if (popupVO.imageLink?.includes("brain.feel-good")) {
      if (!isLoggedIn) {
        setShowPopups(false);
        openAlertModal({
          title: "두뇌유형검사 안내",
          desc: "두뇌유형검사는\n로그인 후 이용 가능합니다.",
          callback: () => {
            setShowPopups(false);
            openModal(ModalType.LOGIN)
          },
        });
        return;
      }

      const accessToken = getValueFromCookie(CookieKeys.ACCESS_TOKEN);
      const refreshToken = getValueFromCookie(CookieKeys.REFRESH_TOKEN);
      const url = `https://brain.feel-good.io?accessToken=${accessToken}&refreshToken=${refreshToken}`;

      if (!isDesktop) {
        setShowPopups(false);
        openConfirmModal(
            {
              title: "두뇌유형검사 안내",
              desc: "두뇌유형검사는 \n가로모드만 지원 합니다. \n가로모드 전환 후 확인을 눌러주세요.",
            },
            () => {
              window.open(url)
            }
        );
        return;
      }
      setShowPopups(false);
      window.open(url);
    }else {
      window.open(popupVO.imageLink, popupVO.linkOption === PopupLinkOption.NEW_TAB ? "_blank" : "_self");
    }
    // eslint-disable-next-line
  }, [popupVO]);

  return (
    <div
      className={`${style.aPopupSlide} ${popupVO.imageLink ? style.link : ""}`}
      draggable={true}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onClick={onClickPopup}
      style={{
        backgroundImage: `url(${popupVO.image.uri})`,
      }}
    ></div>
  );
}
